import Download16 from '@carbon/icons-react/es/download/16';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormInstanceApi } from 'api/form';
import { Menu } from 'components/atoms/dropdown/menu';
import { MoreActionsDropdown } from 'components/atoms/more-actions';
import { DownloadLink } from 'components/molecules/download-link/download-link';
import {
  Title,
  AttachmentDetails,
  Attachment,
  AttachmentCard,
} from './attachment-modal.styles';
import { AttachmentFormAnswerImage } from './attachments-modal';
import {
  AttachmentIconRenderer,
  AttachmentCardCoverRenderer,
} from './icon-renderer';

export type ListType = 'list' | 'grid';

export const AttachmentRenderer = ({
  attachment,
  type = 'list',
}: {
  attachment: AttachmentFormAnswerImage;
  type?: ListType;
}): JSX.Element => {
  switch (type) {
    case 'grid': {
      return (
        <Attachment>
          <AttachmentCard
            cover={<AttachmentCardCoverRenderer element={attachment} />}
            actions={[
              <MoreActionsDropdown
                className="attachment-card-more-actions"
                placement="bottomLeft"
                menu={
                  <Menu>
                    <Menu.Item key="download" icon={<Download16 />}>
                      <DownloadLink
                        url={FormInstanceApi.downloadFormAttachment(
                          attachment.attachmentId,
                        )}
                      >
                        <FormattedMessage id="download_attachment" />
                      </DownloadLink>
                    </Menu.Item>
                  </Menu>
                }
              />,
            ]}
          >
            <AttachmentCard.Meta
              title={<Title>{attachment.name}</Title>}
              description={
                <AttachmentDetails>
                  <FormattedMessage
                    id="projects.form_responses.attachment.meta"
                    values={{
                      name: attachment.createdByUserName,
                      date: moment(attachment.createdAt).format('DD MMM YYYY'),
                    }}
                  />
                </AttachmentDetails>
              }
            />
          </AttachmentCard>
        </Attachment>
      );
    }

    default:
    case 'list': {
      return (
        <Attachment>
          <Attachment.Meta
            avatar={<AttachmentIconRenderer element={attachment} />}
            title={<Title>{attachment.name}</Title>}
            description={
              <AttachmentDetails>
                <FormattedMessage
                  id="projects.form_responses.attachment.meta"
                  values={{
                    name: attachment.createdByUserName,
                    date: moment(attachment.createdAt).format('DD MMM YYYY'),
                  }}
                />
              </AttachmentDetails>
            }
          />
          <MoreActionsDropdown
            className="more-actions"
            placement="bottomLeft"
            menu={
              <Menu>
                <Menu.Item key="download" icon={<Download16 />}>
                  <DownloadLink
                    url={FormInstanceApi.downloadFormAttachment(
                      attachment.attachmentId,
                    )}
                  >
                    <FormattedMessage id="download_attachment" />
                  </DownloadLink>
                </Menu.Item>
              </Menu>
            }
          />
        </Attachment>
      );
    }
  }
};
